
export default {
  namespaced: true,
  state: {
    websiteDetails: {
      status: 'Active'
    }
  },
  getters: {

    websiteDetails (state) {
      return state.websiteDetails
    },

    isDifm (state) {
      if (state.websiteDetails) {
        return state.websiteDetails.isDifm
      }
      return null
    },

    websiteAllowedStatus (state) {
      if (state.websiteDetails.status === 'Active' || state.websiteDetails.status === 'Suspended') {
        return true
      }
      return false
    }
  },
  mutations: {
    setWebsiteDetails (state, value) {
      state.websiteDetails = value
    }
  },

  actions: {
    setWebsiteDetails (ctx, status) {
      ctx.commit('setWebsiteDetails', status)
    }
  }
}
